<template>
  <div class="projects">
    <MenuSide></MenuSide>
    <div class="upper-menu" v-if="this.isShowUpMenu">
      <img @click="goToStart" class="menu-icon-left" src="/static/img/global/hippo_logo_white.svg"
           alt="Menu">
      <img @click="goToMenu" class="menu-icon" src="/static/img/menu.svg" alt="Menu">

    </div>
    <div class="projects-header-div"/>
    <div class="projects-tablediv">

      <div class="title-text" v-bind:style="{'text-align':this.mobileSite.titleCenter}">
        <div class="projects-titlediv">OUR WORK</div>
        <img class="line" src="../../static/img/global/purple-line.svg"/>
        <div class="projects-sub-titlediv">We build a user-centered  experience through high-end
          technology for launching successful websites, interfaces and mobile apps.</div>
        </div>
      <div v-if="!this.isMobile" class="projects-table">
        <td v-for="(project, index) in projects">
          <div v-if="project.image" class="two-images">
            <img v-if="project.isActive" :src="project.hoverImage" class="project-image-hover"
                 @mouseleave="project.isActive = false" @click="showAppDetails(index)">
            <img :src="checkIfMobile(project)" class="project-image"  @mouseover="project.isActive = true"
                 @click="showAppDetails(index)">
          </div>
        </td>
      </div>
      <div v-else class="mobile-projects-table">
        <td v-for="(project, index) in projects">
          <div v-if="project.image">
            <img :src="project.logo" class="mobile-project-image" v-bind:style="{'width':screenWidth + 'px'}" @click="showAppDetails(index)">
          </div>
        </td>
      </div>
    </div>
    <ContactUs></ContactUs>
  </div>
</template>
<script>
  //import MenuSide from "../components/MenuSide";
  //import ContactUs from "../components/ContactUs";

  import MenuSide from '@bit/hippotec.website2019.menu-side';
  import ContactUs from '@bit/hippotec.website2019.contact-us';

  export default {
    name: 'Projects',
    data() {
      return {
        isShowUpMenu: false,
        upperMenuTopLast: 0,
        screenWidth: '0px',
        mobileSite: {
          titleCenter: 'left'
        },
        projects: window.projectsData,
        window,
        isMobile: Boolean
      }
    },
    components: {
      ContactUs,
      MenuSide: MenuSide
    },
    methods: {
      goToStart: function () {
        this.$router.push('/what-we-do');
      },
      goToMenu: function () {
        this.$router.push('/site-menu');
      },
      seeOurProjects: function () {
        this.$router.push('/projects')
      },
      checkScroll() {
        var $win = $(window);
        if ($win.scrollTop() > 200) {
          if (this.upperMenuTopLast > $win.scrollTop()) {
            this.isShowUpMenu = true;
          } else {
            this.isShowUpMenu = false;
          }
          this.upperMenuTopLast = $win.scrollTop()
        } else {
          this.isShowUpMenu = false;
        }
      },
      showAppDetails: function (index) {
        this.$router.push('/cover/' + index);
      },
      checkIfMobile: function (project) {
        if (this.isMobile)
          return project.logo
        else
          return project.image
      },
      prepareMobile(isMobile) {
        this.isMobile = isMobile;
        if (isMobile) {
          this.mobileSite.titleCenter = 'center';
          this.screenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
        }
      }
    },
    created() {
      this.prepareMobile(localStorage.isMobile == 'true');
    },
    mounted() {
      var $win = $(window);
      $win.scroll(this.checkScroll);
      var ourWorkTitle = document.getElementsByClassName("title-text");
      if (!this.isMobile){
        var projectImage = document.getElementsByClassName("project-image")[0];
        var bodyRect = document.body.getBoundingClientRect();
        projectImage = projectImage.getBoundingClientRect();
        let offset   = projectImage.top - bodyRect.top;
        ourWorkTitle[0].style.marginLeft = "" + offset + "px"
      }else{
        /*if(ourWorkTitle && ourWorkTitle.length > 0)
          ourWorkTitle[0].style.marginLeft = "20px"*/
      }
    },
  }
</script>
<style lang="scss" scoped>
  @import "../assets/scss/projects.scss";

  .upper-menu {
    position: fixed;
    opacity: 0.7;
    width: 100%;
    height: 110px;
    background-color: #000000;
    top: 0;
    left: 0;
    z-index: 2000;
  }
  .menu-icon-left {
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    float: left;
    cursor: pointer;
    left: 56px
  }
  .menu-icon {
    position: absolute;
    float: right;
    width: 52px;
    height: 52px;
    cursor: pointer;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    right: 56px;
    animation: menuclose-icon-right 1s forwards 1s;
  }

  .projects-titlediv {
    font-family: Rubik, sans-serif;
    font-size: 60px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.1;
    letter-spacing: normal;
    color: #514077;
  }
  .mobile-project-image {
    object-fit: contain;
    z-index: 1;
    padding-left: 12px;
    padding-right: 12px;
    padding-bottom: 6px;
    padding-top: 6px;
  }
  .mobile-project-image-hover {
    position: absolute;
    object-fit: contain;
    z-index: 2;
    margin: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .mobile-two-images {
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Projects.vue